(function() {	
	/******************
		* This is a basic helper function that allows you to extend one object into another
		* Useful for overwriting default options
		* Usage Examples:
			var defaults = {num: 1, str: 'hi', bool: false}
			var selections = {str: 'goodbye'}
			var merged = blue.meth.extend({}, defaults, selections)

			//merged -> {num: 1, str: 'goodbye', bool: false}

	******************/
	const extend = blue.meth.extend = function(out) {
		out = out || {};
		for (var i = 1; i < arguments.length; i++) {
			var obj = arguments[i];
			if (!obj)
				continue;
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (typeof obj[key] === 'object')
						out[key] = deepExtend(out[key], obj[key]);
					else
						out[key] = obj[key];
				}
			}
		}
		return out;
	}
})();